// U-04 fase a2 · lo que el asistente calcula sin pintar nada (DISEÑO-U-04
// §5.3 y §6.1).
//
// EL PASO NO SE GUARDA, SE CALCULA. Igual que el primer arranque de la
// empresa (`arranque.py`): lo dicen la migración (si ya se contestó cómo se
// lleva el inventario y dónde está) y el `siguiente` del resumen, que
// calcula el servidor con los datos. Un contador en la pantalla se
// desfasaría en cuanto alguien guardara desde otro teléfono o desde la
// revisión, y diría «Paso 3» con todo ya guardado.
//
// La única decisión que vive aquí es «Saltar este paso» del conteo, que es
// opcional (§5.3) y no cambia ningún dato: el servidor seguirá diciendo
// CONTAR mientras haya algo guardado sin contar, porque es verdad.

export const TOTAL_PASOS = 6;

export const PASOS_MIGRACION = [
  { n: 1, nombre: 'Cómo lo llevas' },
  { n: 2, nombre: 'Dónde está' },
  { n: 3, nombre: 'Cargar' },
  { n: 4, nombre: 'Revisar y guardar' },
  { n: 5, nombre: 'Contar para comprobar', opcional: true },
  // a3 lo renombra a «Acta y etiquetas» cuando exista el acta (DISEÑO
  // §6.5); hasta entonces el nombre no promete un papel que no llega.
  { n: 6, nombre: 'Listo en TEGO' },
];

/** «Paso 4 de 6». */
export const textoPaso = (n) => `Paso ${n} de ${TOTAL_PASOS}`;

/** El paso que toca, de los datos del servidor. */
export function pasoDe(migracion, resumen, { saltarConteo = false } = {}) {
  if (!migracion || !migracion.forma_actual) return 1;
  if (!migracion.ubicacion_omision) return 2;
  switch (resumen?.siguiente) {
    case 'REVISAR':
    case 'APLICAR':
      return 4;
    case 'CONTAR':
      return saltarConteo ? 6 : 5;
    case 'ACTA':
    case 'LISTO':
      return 6;
    default:
      return 3;
  }
}

/** Las tres respuestas a «¿Cómo llevas hoy tu inventario?», con lo que pasa después. */
export const FORMAS = [
  { forma: 'EXCEL', titulo: 'En Excel',
    despues: 'Subes tu archivo y revisas lo que TEGO entendió, fila por fila.' },
  { forma: 'LIBRETA', titulo: 'En una libreta',
    despues: 'Pasas cada renglón desde el teléfono: escaneas o escribes el producto y cuántas hay.' },
  { forma: 'NADA', titulo: 'No llevo nada todavía',
    despues: 'Recorres los estantes con el teléfono y capturas lo que ves.' },
];

/** Libreta y nada se cargan capturando; Excel, subiendo el archivo. */
export const seCapturaCon = (forma) => forma === 'LIBRETA' || forma === 'NADA';

/** El código de la ubicación que se crea cuando la empresa no tiene ninguna. */
export const UBICACION_INICIAL = { codigo: 'ALMACEN', nombre: 'Almacén' };

/** «1 fila», «3 filas»; «1 producto», «3 productos». */
export const contar = (n, singular, plural) => `${n} ${Number(n) === 1 ? singular : plural}`;
